import moment from 'moment';

export const now = new Date();
export const getFirstDayOfMonth = (): moment.Moment => moment(1, 'DD');
export const getLastDayOfMonth = (): moment.Moment => moment().endOf('month');

export const getDayDiff = (date: string): number => {
	const startOfToday = moment().startOf('day');
	const startOfDate = moment(date).startOf('day');
	const daysDiff = startOfDate.diff(startOfToday, 'days');
	return daysDiff;
};
